import React from 'react';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';

import 'Components/FacetSearch/FranchiseImgGrid.scss';

import CarouselArrow from 'Components/Carousel/CarouselArrow';
import CarouselPaging from 'Components/Carousel/CarouselPaging';
import FluidImg from 'Components/Utility/FluidImg';
import FluidBackgroundImg from 'Components/Utility/FluidBackgroundImg';
import { getRankedFranchises } from 'Helpers/Franchise/FranchiseHelper';


const FranchiseImgGrid = () => {
  const franchises = getRankedFranchises();

  const heights = {
    xs: 180,
    sm: 180,
    md: 200,
    lg: 230,
    xl: 224,
    xxl: 268,
  };

  const settings = {
    infinite: false,
    prevArrow: <CarouselArrow ariaLabel="Previous" arrowDirection="left" containerClassName="arrow-btn-container" />,
    nextArrow: <CarouselArrow ariaLabel="Next" arrowDirection="right" containerClassName="arrow-btn-container" />,
    slidesToShow: 5,
    slidesToScroll: 5,
    centerMode: false,
    lazyLoad: 'ondemand',
    dots: true,
    accessibility: true,
    customPaging: i => (
      <CarouselPaging slideIndex={i} slideLength={franchises.length} slidesToShow={5}/>
    ),
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          dots: true,
          slidesToShow: 4,
          slidesToScroll: 4,
          customPaging: i => (
            <CarouselPaging slideIndex={i} slideLength={franchises.length} slidesToShow={4}/>
          ),
        },
      },
      {
        breakpoint: 991,
        settings: {
          dots: true,
          slidesToShow: 3,
          slidesToScroll: 3,
          customPaging: i => (
            <CarouselPaging slideIndex={i} slideLength={franchises.length} slidesToShow={3}/>
          ),
        },
      },
      {
        breakpoint: 767,
        settings: {
          dots: true,
          arrows: false,
          slidesToShow: 2,
          slidesToScroll: 2,
          customPaging: i => (
            <CarouselPaging slideIndex={i} slideLength={franchises.length} slidesToShow={2}/>
          ),
        },
      },
      {
        breakpoint: 480,
        settings: {
          dots: true,
          arrows: false,
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 1,
          slidesToScroll: 1,
          customPaging: i => (
            <CarouselPaging slideIndex={i} slideLength={franchises.length} slidesToShow={1}/>
          ),
        },
      },
    ],
  };

  return (
    <Slider {...settings} className="franchise-img-carousel">
      {franchises.slice(0, 15).map(franchise =>
        <Link to={`/franchises/${franchise.slug}`} key={franchise.slug} className={`franchise-grid-segment ${franchise.slug}-segment`}>
          <div className={`franchise-bg ${franchise.slug}-bg`}>
            <FluidBackgroundImg
              folder="assets/franchises"
              className="img-force-full"
              src={franchise.bgImg}
              heights={heights}
              alt={franchise.alt}
              widthOverride={250}
              fit="crop"
            />
          </div>
          <div className="franchise-logo">
            <FluidImg
              folder="assets/franchises"
              className={`img-force-full ${franchise.slug}`}
              src={franchise.logo}
              alt={franchise.alt}
            />
          </div>
        </Link>,
      )}
    </Slider>
  );
};

export default FranchiseImgGrid;
